import { PercentageFormatter } from '../Format/PercentageFormatter';
import { Format } from '../Format/Format';
import Decimal from 'decimal.js';

const MAX_PRICE = 999999999999.99;

export function convertVatpctFromLocale(value, locale) {
  const pctFormat = Format.fromLocale(locale);
  const percent = new Decimal(value).times(100).toNumber();
  const isDecimal =  !Number.isInteger(percent);
  pctFormat.numbers.decimalAccuracy = 1;
  const percentageF = new PercentageFormatter(pctFormat, isDecimal);
  let pctValue = percentageF.render(percent);
  return pctValue;
}

export function isPriceValid(value: number) {
  return value < MAX_PRICE;
}

export function isNonVatPriceValid(nonVatPrice: number, vatPct: number) {
  return isPriceValid(nonVatPrice * (1 + vatPct));
}
